export default defineNuxtPlugin((nuxtApp) => {
    const formatter = {
        price(price, currency, minimumFractionDigits = 2) {
            // console.log('1: ' + currency);
            // console.log('2: ' +  useLocaleStore().currency);
            currency = currency && typeof currency !== 'undefined' ? currency : useLocaleStore().currency.unit_text;
            // console.log('3: ' + currency);
            if (typeof currency === 'undefined') { currency = 'EUR'; }
            // console.log('4: ' + currency);
            // console.log(typeof currency);

            return new Intl.NumberFormat(useLocaleStore().getLanguage(), {
                style: 'currency',
                currency: currency,
                currencyDisplay: 'symbol',
                minimumFractionDigits,
                maximumFractionDigits: 2,
            }).format(price);
        },

        percent(value, minimumFractionDigits = 2) {
            return new Intl.NumberFormat(useLocaleStore().getLanguage(), {
                minimumFractionDigits,
            }).format(value);
        },

        timer(secs) {
            const pad = (n) => n < 10 ? `0${n}` : n;

            const h = Math.floor(secs / 3600);
            const m = Math.floor(secs / 60) - (h * 60);
            const s = Math.floor(secs - h * 3600 - m * 60);

            return `${pad(m)}:${pad(s)}`;
        }
    };

    return {
        provide: {
            formatter: formatter,
        },
    };
});
